module.exports = __webpack_public_path__ + "static/media/hm4.2015fa48.PNG";